import { RemoteConfigVariables } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import {
  Dimensions, Platform, StyleSheet, View,
} from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonSize, ButtonTypes } from '../components';
import Theme from '../theme';
import { RemoteConfigWrapper } from '../ui/components/RemoteConfigWrapper';
import { UserDataConsumer } from '../utils';
import { MyWorkoutResultsCard } from './MyWorkoutResultsCard';
import { HomeInviteButtonsContainer } from './HomeInviteButtonsContainer';

const { width } = Dimensions.get('window');
const isMobile = width < 640;

interface IProps {
  navigation?: any;
  fullname: string;
  workoutDuration: string;
  workoutDate: string;
  level: string;
  effortPoints?: string;
  effortPercentage?: string;
  calories?: string;
  cardioOrResistance: string;
  bodyGroups: string;
  hideButtons?: boolean;
  screenShotMode?: boolean;
  averageHeartRate?: string;

  t(key: string, options?: any): string;
}

class HomeMyWorkoutResults extends PureComponent<IProps> {
  constructor(props: any) {
    super(props);
  }

  public goToLogin = () => {
    this.props.navigation.navigate('Login');
  }

  public render() {
    const { t } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.body}>
          <MyWorkoutResultsCard {...this.props} isMobile={isMobile}/>
          <HomeInviteButtonsContainer
            {...this.props}
            isMobile={isMobile}
            renderInviteText={()=>null}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    backgroundColor: Theme.GREY_DARK,
  },
  body: {
    marginTop: -50,
    paddingBottom: 30,
    justifyContent: 'flex-end',
    backgroundColor: Theme.GREY_DARK,
    padding: isMobile ? 10 : 0,
    ...Platform.select({
      web: {
        marginTop: 0,
        paddingTop: isMobile ? 0 : 20,
        justifyContent: !isMobile ? 'center' : 'flex-end',
      },
    }),
  },
});

const mapStateToProps = (state) => {
  return { ...state.deepLinkParamaters };
};

export const HomeMyWorkoutResultsScreen = translate(['auth', 'formFields'], { wait: true })(
  UserDataConsumer(connect(mapStateToProps)(HomeMyWorkoutResults)),
);
